export default {"src":"/_next/static/media/KeepaLogoDeactive.6c4070c5.svg","height":40,"width":40};